import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Mail from 'react-feather/dist/icons/mail.js'
import Phone from 'react-feather/dist/icons/phone.js'
import Calendar from 'react-feather/dist/icons/calendar.js'

import Date from '../../../../../shared/components/Moment/Date.jsx'

import './PurchaserDetails.scss'

export default class PurchaserDetails extends PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.number.isRequired
    }).isRequired,
  }

  render() {
    const {user} = this.props
    const fullname = (user?.fullname ?? '').trim()
    const title = fullname === '' ? `#${user.id}` : fullname

    return <div className="purchaser-details">
      <Helmet>
        <title>DO {title}</title>
      </Helmet>
      <div className="row intro">
        <div className="col-xxl-12 title">
          <h1>{title}</h1>
          {fullname !== '' ? <p className="id">&nbsp;#{user.id}</p> : ''}
        </div>
        <div className="col-xxl-12 details">
          <h2 className="job">
            {user.fonction ? this.props.user.fonction : ''}
            {user.company ? ` @${this.props.user.company}` : ''}
          </h2>
          <p className="email">
            <Mail size={20}/>&nbsp;{user.email}
          </p>
          <p className="tel"><Phone size={20}/>&nbsp;{this.props.user.tel}</p>
          <p className="subscription">
            <Calendar size={20}/>&nbsp;Inscrit le&nbsp;<Date date={user.date_created}/>
          </p>
        </div>
      </div>
    </div>
  }
}
